module.exports = __webpack_public_path__ + "assets/TrByIncircleBasesDetailed.146ab4c6de7885419266dd12016403f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrByIncircleBasesDetailed.png
// module id = 588
// module chunks = 0